import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataProcessingService } from './data-prcessing.service';

import { GenericResponseWithTotal } from '../interfaces/generic.interface';
import { Card, NewUserCard } from '../interfaces/cards.interface';
import { Observable } from 'rxjs';
import { ContactForm } from '../interfaces/contact.interface';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private get apiUrl(): string {
    return this.loggerService.resolveApiUrl('contact');
  }

  constructor(
    private http: HttpClient,
    private dataProcess: DataProcessingService,
    private loggerService: LoggerService
  ) { }

  sendContactForm(cardData: ContactForm): Observable<void> {
    return this.http.post<void>(
      `${this.apiUrl}/send`, cardData
    );
  }

  sendPartnerContactForm(cardData: ContactForm): Observable<void> {
    return this.http.post<void>(
      `${this.apiUrl}/send-partner`, cardData
    );
  }


}
